module.exports = __webpack_public_path__ + "img/RCREG.3e4769ed.svg";